import { createFileRoute } from "@tanstack/react-router";
import Activities from "@/pages/Activities";
import { buildNoindexHead, noindexLoader, type NoindexSEO } from "@/lib/noindex-route-seo";

const TITLES: NoindexSEO = {
  "es": "Actividades y tours",
  "pt-BR": "Atividades e passeios",
  "en": "Activities and tours",
  "en-EU": "Activities and tours",
};

export const Route = createFileRoute("/actividades")({
  loader: noindexLoader,
  head: ({ loaderData }) => buildNoindexHead(TITLES, "/actividades", loaderData),
  component: Activities,
});
